'use client';

// Wraps button in a link so we can style links as buttons
import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import React from 'react';
import Button from './Button';
type Props = {
  href: string;
  variant?: 'PRIMARY' | 'SECONDARY' | 'WARNING' | 'DANGER' | 'CLEAR' | 'TRANSPARENT';
  text?: string;
  titleElement?: React.ReactNode;
  classNames?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  icon?: React.ReactNode;
  id?: string;
  tooltip?: string;
  target?: string;
  rel?: string;
};
const LinkButton = t0 => {
  const $ = _c(43);
  let buttonProps;
  let classNames;
  let disabled;
  let href;
  let icon;
  let id;
  let loading;
  let onClick;
  let rel;
  let t1;
  let target;
  let text;
  let titleElement;
  let tooltip;
  if ($[0] !== t0) {
    ({
      href,
      variant: t1,
      text,
      classNames,
      onClick,
      disabled,
      loading,
      titleElement,
      icon,
      id,
      tooltip,
      target,
      rel,
      ...buttonProps
    } = t0);
    $[0] = t0;
    $[1] = buttonProps;
    $[2] = classNames;
    $[3] = disabled;
    $[4] = href;
    $[5] = icon;
    $[6] = id;
    $[7] = loading;
    $[8] = onClick;
    $[9] = rel;
    $[10] = t1;
    $[11] = target;
    $[12] = text;
    $[13] = titleElement;
    $[14] = tooltip;
  } else {
    buttonProps = $[1];
    classNames = $[2];
    disabled = $[3];
    href = $[4];
    icon = $[5];
    id = $[6];
    loading = $[7];
    onClick = $[8];
    rel = $[9];
    t1 = $[10];
    target = $[11];
    text = $[12];
    titleElement = $[13];
    tooltip = $[14];
  }
  const variant = t1 === undefined ? "PRIMARY" : t1;
  if (disabled) {
    let t2;
    if ($[15] !== buttonProps || $[16] !== classNames || $[17] !== disabled || $[18] !== icon || $[19] !== id || $[20] !== loading || $[21] !== text || $[22] !== titleElement || $[23] !== tooltip || $[24] !== variant) {
      t2 = <Button variant={variant} text={text} titleElement={titleElement} classNames={classNames} disabled={disabled} loading={loading} icon={icon} id={id} tooltip={tooltip} {...buttonProps} />;
      $[15] = buttonProps;
      $[16] = classNames;
      $[17] = disabled;
      $[18] = icon;
      $[19] = id;
      $[20] = loading;
      $[21] = text;
      $[22] = titleElement;
      $[23] = tooltip;
      $[24] = variant;
      $[25] = t2;
    } else {
      t2 = $[25];
    }
    return t2;
  }
  let t2;
  if ($[26] !== buttonProps || $[27] !== classNames || $[28] !== disabled || $[29] !== icon || $[30] !== id || $[31] !== loading || $[32] !== text || $[33] !== titleElement || $[34] !== tooltip || $[35] !== variant) {
    t2 = <Button variant={variant} text={text} titleElement={titleElement} classNames={classNames} disabled={disabled} loading={loading} icon={icon} id={id} tooltip={tooltip} {...buttonProps} />;
    $[26] = buttonProps;
    $[27] = classNames;
    $[28] = disabled;
    $[29] = icon;
    $[30] = id;
    $[31] = loading;
    $[32] = text;
    $[33] = titleElement;
    $[34] = tooltip;
    $[35] = variant;
    $[36] = t2;
  } else {
    t2 = $[36];
  }
  let t3;
  if ($[37] !== href || $[38] !== onClick || $[39] !== rel || $[40] !== t2 || $[41] !== target) {
    t3 = <Link href={href} target={target} rel={rel} onClick={onClick} className="no-underline">{t2}</Link>;
    $[37] = href;
    $[38] = onClick;
    $[39] = rel;
    $[40] = t2;
    $[41] = target;
    $[42] = t3;
  } else {
    t3 = $[42];
  }
  return t3;
};
export default LinkButton;